import Dialog from "@material-ui/core/Dialog"
import IconButton from "@material-ui/core/IconButton"
import Slide from "@material-ui/core/Slide"
import { makeStyles } from "@material-ui/core/styles"
import { Button, CircularProgress, Typography } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import React, { useEffect, useState } from "react"
import api from "../services/api"
import { RegistrarLogErro } from "../services/clientefiel"
import useAppStore from "../stores/AppStore"

// ============================ CONFIGURAÇÃO ============================
// Id do jogo no backend (tabela VotoJogoCopa).
// ⚠️ AJUSTE para o id real do jogo Brasil x Japão cadastrado na API.
const ID_JOGO = 1

// Endpoints do webservice de votação (a baseURL do api já inclui ".../rest/").
// POST votar: body { idJogo, voto: "A"|"B"|"EMPATE", appNome? }. X-Visitor-Id vai no header (interceptor).
const ENDPOINT_VOTAR = "votacao-copa/votar"
// GET parcial: votacao-copa/resultado/{idJogo}
const ENDPOINT_RESULTADO = "votacao-copa/resultado/"

// Opções de palpite (ordem de exibição). Não há empate (mata-mata).
// "voto" = código enviado à API; "campoResultado" = campo correspondente na parcial.
// ⚠️ Confirme com o backend qual time é "A" e qual é "B" neste jogo.
const OPCOES = [
    { id: "brasil", label: "Brasil", emoji: "🇧🇷", cor: "#009c3b", voto: "A", campoResultado: "vitoriaA" },
    { id: "japao", label: "Japão", emoji: "🇯🇵", cor: "#bc002d", voto: "B", campoResultado: "vitoriaB" },
]

// Prazo para VOTAR / ALTERAR o voto: 29/06/2026 às 15:00 (Brasília, UTC-3) = 18:00 UTC.
// Após esse instante não é mais possível votar nem alterar o voto.
const PRAZO_VOTACAO = new Date("2026-06-29T18:00:00Z")

// Prazo para VISUALIZAR o resultado (ícone no menu + parcial): fim do dia 29/06
// no horário de Brasília = 00:00 de 30/06 BRT = 03:00 UTC de 30/06.
const PRAZO_EXIBICAO = new Date("2026-06-30T03:00:00Z")

// Comparar com Date() funciona em qualquer fuso, pois ambos são instantes absolutos.

// Mostrar o popup apenas 1x por sessão (sessionStorage).
const CHAVE_SESSAO = "enqueteVistaCF_" + ID_JOGO
// Guarda o voto do usuário entre sessões (localStorage) para já mostrar o gráfico.
const CHAVE_VOTO = "enqueteVotoCF_" + ID_JOGO
// =====================================================================

// Evento global para outro componente abrir a parcial da votação.
export const EVENTO_ABRIR_ENQUETE = "abrirEnqueteResultado"

// A votação (registrar/alterar voto) só fica aberta até o PRAZO_VOTACAO.
export function votacaoAberta() {
    return new Date() < PRAZO_VOTACAO
}

// O resultado (ícone no menu + parcial) fica visível até o fim do dia 29/06.
export function enqueteVisivel() {
    return new Date() < PRAZO_EXIBICAO
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
    paper: {
        position: "relative",
        overflow: "visible",
        borderRadius: 12,
        margin: 16,
        width: "min(420px, 92vw)",
        padding: "24px 20px",
    },
    botaoFechar: {
        position: "absolute",
        top: -16,
        right: -16,
        backgroundColor: "white",
        color: "#333",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        padding: 6,
        "&:hover": { backgroundColor: "white", filter: "brightness(0.95)" },
    },
    titulo: {
        textAlign: "center",
        fontWeight: 700,
        marginBottom: 4,
    },
    subtitulo: {
        textAlign: "center",
        color: theme.palette.text.secondary,
        marginBottom: 20,
    },
    opcoes: {
        display: "flex",
        flexDirection: "row",
        gap: 10,
    },
    botaoOpcao: {
        flex: 1,
        minWidth: 0,
        flexDirection: "column",
        padding: "18px 4px",
        textTransform: "none",
    },
    emojiBotao: {
        fontSize: "3.5rem",
        lineHeight: 1,
    },
    textoOpcao: {
        fontSize: "1rem",
        fontWeight: 600,
        marginTop: 6,
    },
    emoji: { marginRight: 8, fontSize: "1.1rem" },
    carregando: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
        padding: "16px 0",
    },
    // ---- gráfico de barras ----
    barraLinha: { marginBottom: 14 },
    barraTopo: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 4,
    },
    barraLabel: { fontWeight: 600 },
    barraPorcentagem: { fontWeight: 700 },
    barraTrilho: {
        backgroundColor: "#ececec",
        borderRadius: 8,
        height: 22,
        overflow: "hidden",
    },
    barraPreenchida: {
        height: "100%",
        borderRadius: 8,
        transition: "width 0.6s ease",
        minWidth: 2,
    },
    barraEscolhida: {
        outline: "2px solid #333",
        outlineOffset: 1,
        borderRadius: 8,
    },
    totalVotos: {
        textAlign: "center",
        color: theme.palette.text.secondary,
        marginTop: 8,
    },
    erro: {
        textAlign: "center",
        color: theme.palette.error.main,
        marginTop: 8,
    },
    // ---- bloco de pênaltis no resultado ----
    penaltisBloco: {
        marginTop: 18,
        paddingTop: 14,
        borderTop: "1px solid #e0e0e0",
    },
    penaltisTitulo: {
        fontWeight: 700,
        textAlign: "center",
        marginBottom: 12,
    },
    // ---- botão de rodapé (votar / alterar voto) ----
    botaoRodape: {
        marginTop: 18,
        textTransform: "none",
        fontWeight: 700,
    },
    votacaoEncerrada: {
        marginTop: 18,
        textAlign: "center",
        fontWeight: 700,
        color: theme.palette.text.secondary,
    },
}))

// Normaliza a resposta da API (ResultadoVotacaoCopa) para { brasil, japao, total }.
// Resposta esperada: { vitoriaA, vitoriaB, empate, total, penaltisSim, penaltisNao }.
function normalizarResultados(data) {
    const base = { total: 0, penaltisSim: 0, penaltisNao: 0 }
    OPCOES.forEach(o => {
        base[o.id] = 0
    })
    if (!data) return base
    OPCOES.forEach(o => {
        base[o.id] = Number(data[o.campoResultado]) || 0
    })
    // Denominador das porcentagens do vencedor: apenas Brasil + Japão.
    base.total = OPCOES.reduce((soma, o) => soma + base[o.id], 0)
    // Palpites de pênaltis (contam só quem respondeu).
    base.penaltisSim = Number(data.penaltisSim) || 0
    base.penaltisNao = Number(data.penaltisNao) || 0
    return base
}

// Lê o voto salvo: { opcao, penaltis } (com compatibilidade ao formato antigo em string).
function lerVotoSalvo() {
    const raw = localStorage.getItem(CHAVE_VOTO)
    if (!raw) return null
    try {
        const obj = JSON.parse(raw)
        if (obj && typeof obj === "object" && obj.opcao) return obj
    } catch (_) {}
    return { opcao: raw, penaltis: null }
}

function salvarVoto(opcao, penaltis) {
    localStorage.setItem(CHAVE_VOTO, JSON.stringify({ opcao, penaltis }))
}

// Reflete o voto do usuário na parcial imediatamente, sem depender do lag de
// leitura pós-escrita. Trata troca de voto (remove o anterior) para não contar em dobro.
function aplicarVotoOtimista(baseline, votoAnterior, opcao, penaltis) {
    const r = { ...baseline }
    if (votoAnterior && votoAnterior.opcao) {
        if (r[votoAnterior.opcao] != null) {
            r[votoAnterior.opcao] = Math.max(0, r[votoAnterior.opcao] - 1)
        }
        if (votoAnterior.penaltis === true) r.penaltisSim = Math.max(0, r.penaltisSim - 1)
        else if (votoAnterior.penaltis === false) r.penaltisNao = Math.max(0, r.penaltisNao - 1)
    }
    r[opcao.id] = (r[opcao.id] || 0) + 1
    if (penaltis === true) r.penaltisSim = (r.penaltisSim || 0) + 1
    else if (penaltis === false) r.penaltisNao = (r.penaltisNao || 0) + 1
    r.total = OPCOES.reduce((soma, o) => soma + (r[o.id] || 0), 0)
    return r
}

export default function PopupEnquete() {
    const classes = useStyles()
    const appNome = useAppStore(s => s.configuracoes?.user?.parametros?.appNome)
    // Gatilho reativo de login: configuracoes.user é preenchido ao autenticar.
    const usuarioLogado = useAppStore(s => Boolean(s.configuracoes?.user))
    const [dentroDoPrazo] = useState(() => votacaoAberta())
    const [aberto, setAberto] = useState(false)
    const [etapa, setEtapa] = useState("votar") // "votar" | "penaltis" | "resultado"
    const [escolhaVencedor, setEscolhaVencedor] = useState(null)
    const [carregando, setCarregando] = useState(false)
    const [resultados, setResultados] = useState(null)
    const [votoUsuario, setVotoUsuario] = useState(null)
    const [erro, setErro] = useState("")

    useEffect(() => {
        if (!dentroDoPrazo) return undefined
        // Só pede o voto após o usuário estar logado (configuracoes.user + token).
        if (!usuarioLogado || !localStorage.getItem("chaveSistema")) return undefined
        if (sessionStorage.getItem(CHAVE_SESSAO) === "1") return undefined

        const votoSalvo = lerVotoSalvo()
        const timer = setTimeout(() => {
            setAberto(true)
            if (votoSalvo) {
                // Já votou antes: mostra direto o gráfico.
                setVotoUsuario(votoSalvo.opcao)
                setEtapa("resultado")
                carregarResultados()
            }
        }, 1200)
        return () => clearTimeout(timer)
    }, [dentroDoPrazo, usuarioLogado])

    // Permite que outro componente abra a parcial da votação.
    useEffect(() => {
        const handler = () => abrirResultados()
        window.addEventListener(EVENTO_ABRIR_ENQUETE, handler)
        return () => window.removeEventListener(EVENTO_ABRIR_ENQUETE, handler)
    }, [])

    const carregarResultados = async () => {
        setCarregando(true)
        setErro("")
        try {
            const response = await api.get(ENDPOINT_RESULTADO + ID_JOGO)
            setResultados(normalizarResultados(response.data))
        } catch (error) {
            RegistrarLogErro(error, "carregarResultadosEnquete", { idJogo: ID_JOGO })
            setErro("Não foi possível carregar os resultados agora.")
        } finally {
            setCarregando(false)
        }
    }

    // Encerra a votação: vai direto para a parcial (usado quando o prazo expira).
    const encerrarVotacao = () => {
        setErro("")
        setEtapa("resultado")
        carregarResultados()
    }

    // 1ª etapa: usuário escolhe o vencedor -> vai para a pergunta dos pênaltis.
    const escolherVencedor = opcaoId => {
        if (!votacaoAberta()) {
            encerrarVotacao()
            return
        }
        setErro("")
        setEscolhaVencedor(opcaoId)
        setEtapa("penaltis")
    }

    // 2ª etapa: usuário responde se vai para os pênaltis -> conclui o voto.
    const registrarVoto = async penaltis => {
        const opcao = OPCOES.find(o => o.id === escolhaVencedor)
        if (!opcao) return
        if (!votacaoAberta()) {
            encerrarVotacao()
            return
        }
        setCarregando(true)
        setErro("")
        try {
            const votoAnterior = lerVotoSalvo()
            // Baseline atual da parcial, para refletir o voto na hora (a leitura
            // logo após o POST pode não enxergar o voto recém-gravado).
            let baseline = null
            try {
                const r = await api.get(ENDPOINT_RESULTADO + ID_JOGO)
                baseline = normalizarResultados(r.data)
            } catch (_) {}

            const body = { idJogo: ID_JOGO, voto: opcao.voto, penaltis }
            if (appNome) body.appNome = appNome
            await api.post(ENDPOINT_VOTAR, body)

            salvarVoto(opcao.id, penaltis)
            setVotoUsuario(opcao.id)
            setEtapa("resultado")

            if (baseline) {
                setResultados(aplicarVotoOtimista(baseline, votoAnterior, opcao, penaltis))
                setCarregando(false)
            } else {
                await carregarResultados()
            }
        } catch (error) {
            RegistrarLogErro(error, "registrarVotoEnquete", {
                idJogo: ID_JOGO,
                voto: opcao.voto,
                penaltis,
            })
            setErro("Não foi possível registrar seu voto. Tente novamente.")
            setCarregando(false)
        }
    }

    const fechar = () => {
        sessionStorage.setItem(CHAVE_SESSAO, "1")
        setAberto(false)
    }

    // Reabre o popup já na parcial da votação (acionado por evento externo).
    const abrirResultados = () => {
        const votoSalvo = lerVotoSalvo()
        if (votoSalvo) setVotoUsuario(votoSalvo.opcao)
        setEtapa("resultado")
        setAberto(true)
        carregarResultados()
    }

    // Volta para a 1ª etapa (votar / alterar o voto) a partir do resultado.
    const irParaVotacao = () => {
        setErro("")
        setEscolhaVencedor(null)
        setEtapa("votar")
    }

    const totalVotos = resultados
        ? OPCOES.reduce((soma, o) => soma + (resultados[o.id] || 0), 0)
        : 0

    return (
        <>
            <Dialog
                open={aberto}
                onClose={fechar}
                TransitionComponent={Transition}
                classes={{ paper: classes.paper }}
                aria-labelledby="popup-enquete"
            >
            <IconButton
                className={classes.botaoFechar}
                size="small"
                onClick={fechar}
                aria-label="fechar"
            >
                <CloseIcon fontSize="small" />
            </IconButton>

            <Typography variant="h6" className={classes.titulo}>
                ⚽ Brasil x Japão
            </Typography>

            {etapa === "votar" ? (
                <>
                    <Typography variant="body2" className={classes.subtitulo}>
                        Quem você acha que vai vencer?
                    </Typography>

                    {carregando ? (
                        <div className={classes.carregando}>
                            <CircularProgress size={28} />
                            <Typography variant="body2">Registrando seu voto...</Typography>
                        </div>
                    ) : (
                        <div className={classes.opcoes}>
                            {OPCOES.map(o => (
                                <Button
                                    key={o.id}
                                    variant="outlined"
                                    color="primary"
                                    className={classes.botaoOpcao}
                                    onClick={() => escolherVencedor(o.id)}
                                >
                                    <span className={classes.emojiBotao} role="img" aria-label={o.label}>
                                        {o.emoji}
                                    </span>
                                </Button>
                            ))}
                        </div>
                    )}
                    {erro ? (
                        <Typography variant="body2" className={classes.erro}>
                            {erro}
                        </Typography>
                    ) : null}
                </>
            ) : etapa === "penaltis" ? (
                <>
                    <Typography variant="body2" className={classes.subtitulo}>
                        Você acha que vai ser decidido nos pênaltis?
                    </Typography>

                    {carregando ? (
                        <div className={classes.carregando}>
                            <CircularProgress size={28} />
                            <Typography variant="body2">Registrando seu voto...</Typography>
                        </div>
                    ) : (
                        <div className={classes.opcoes}>
                            <Button
                                variant="outlined"
                                color="primary"
                                className={classes.botaoOpcao}
                                onClick={() => registrarVoto(true)}
                            >
                                <span className={classes.emojiBotao} role="img" aria-label="Sim">
                                    ✅
                                </span>
                                <span className={classes.textoOpcao}>Sim</span>
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                className={classes.botaoOpcao}
                                onClick={() => registrarVoto(false)}
                            >
                                <span className={classes.emojiBotao} role="img" aria-label="Não">
                                    🚫
                                </span>
                                <span className={classes.textoOpcao}>Não</span>
                            </Button>
                        </div>
                    )}
                    {erro ? (
                        <Typography variant="body2" className={classes.erro}>
                            {erro}
                        </Typography>
                    ) : null}
                </>
            ) : (
                <>
                    <Typography variant="body2" className={classes.subtitulo}>
                        {votoUsuario
                            ? "Obrigado pelo seu palpite! Veja como está a votação:"
                            : "Veja como está a votação:"}
                    </Typography>

                    {carregando ? (
                        <div className={classes.carregando}>
                            <CircularProgress size={28} />
                            <Typography variant="body2">Carregando resultados...</Typography>
                        </div>
                    ) : resultados ? (
                        <>
                            {OPCOES.map(o => {
                                const votos = resultados[o.id] || 0
                                const pct = totalVotos > 0 ? Math.round((votos / totalVotos) * 100) : 0
                                const escolhida = votoUsuario === o.id
                                return (
                                    <div key={o.id} className={classes.barraLinha}>
                                        <div className={classes.barraTopo}>
                                            <Typography variant="body2" className={classes.barraLabel}>
                                                <span className={classes.emoji}>{o.emoji}</span>
                                                {o.label}
                                                {escolhida ? " (seu voto)" : ""}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                className={classes.barraPorcentagem}
                                            >
                                                {pct}%
                                            </Typography>
                                        </div>
                                        <div
                                            className={`${classes.barraTrilho} ${
                                                escolhida ? classes.barraEscolhida : ""
                                            }`}
                                        >
                                            <div
                                                className={classes.barraPreenchida}
                                                style={{ width: `${pct}%`, backgroundColor: o.cor }}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                            <Typography variant="body2" className={classes.totalVotos}>
                                {totalVotos} {totalVotos === 1 ? "voto" : "votos"} no total
                            </Typography>
                            {resultados.penaltisSim + resultados.penaltisNao > 0 ? (
                                <div className={classes.penaltisBloco}>
                                    <Typography variant="body2" className={classes.penaltisTitulo}>
                                        Vai ser decidido nos pênaltis?
                                    </Typography>
                                    {[
                                        { rotulo: "Sim", valor: resultados.penaltisSim, cor: "#f9a825" },
                                        { rotulo: "Não", valor: resultados.penaltisNao, cor: "#607d8b" },
                                    ].map(item => {
                                        const totalP =
                                            resultados.penaltisSim + resultados.penaltisNao
                                        const pct =
                                            totalP > 0 ? Math.round((item.valor / totalP) * 100) : 0
                                        return (
                                            <div key={item.rotulo} className={classes.barraLinha}>
                                                <div className={classes.barraTopo}>
                                                    <Typography
                                                        variant="body2"
                                                        className={classes.barraLabel}
                                                    >
                                                        {item.rotulo}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        className={classes.barraPorcentagem}
                                                    >
                                                        {pct}%
                                                    </Typography>
                                                </div>
                                                <div className={classes.barraTrilho}>
                                                    <div
                                                        className={classes.barraPreenchida}
                                                        style={{
                                                            width: `${pct}%`,
                                                            backgroundColor: item.cor,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            ) : null}
                        </>
                    ) : (
                        <Typography variant="body2" className={classes.erro}>
                            {erro || "Sem resultados no momento."}
                        </Typography>
                    )}
                    {!carregando ? (
                        votacaoAberta() ? (
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                className={classes.botaoRodape}
                                onClick={irParaVotacao}
                            >
                                {votoUsuario ? "Alterar voto" : "Votar"}
                            </Button>
                        ) : (
                            <Typography
                                variant="caption"
                                component="p"
                                className={classes.votacaoEncerrada}
                            >
                                Votação encerrada
                            </Typography>
                        )
                    ) : null}
                </>
            )}
            </Dialog>
        </>
    )
}
